import React from "react";
import { useTranslation } from "react-i18next";
import HardwareFeatures from "../HardwareFeatures";
import { TrackerHardwareFeatures as trackerFeaturesData, trackerColorTheme } from "./TrackerData";

const TrackerHardwareFeatures: React.FC = () => {
    const { t } = useTranslation("hardwareFeatures");

    return (
        <HardwareFeatures
            features={trackerFeaturesData}
            colorTheme={trackerColorTheme}
            regularText={t("tracker.regularText")}
            highlightedText={t("tracker.highlightedText")}
            descriptionText={t("tracker.descriptionText")}
        />
    );
};

export default TrackerHardwareFeatures;